"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EProjectPurpose = void 0;
exports.EProjectPurpose = {
    FUNDING_APPLICATION: "FUNDING_APPLICATION",
    AUTHENTICITY_PROTECTION: "AUTHENTICITY_PROTECTION",
    PITCH_TO_PROFESSIONALS: "PITCH_TO_PROFESSIONALS",
};
